

jQuery('document').ready(function() {

	(function($) {
	  'use strict';

	  //create temporal object to get slick object
	  var getSlick = function() {
	    var $tmp = $('<div>').slick();
	    var slick = $tmp[0].slick.constructor;
	    $tmp.slick('unslick');
	    return slick;
	  };

	  if ($.fn.slick) {
	    var Slick = getSlick();
	    if (Slick) {
	      //hook checkResponsive method
	      var checkResponsiveOrig = Slick.prototype.checkResponsive;
	      Slick.prototype.checkResponsive = function(initial, forceUpdate) {
	        var _ = this;
	        if (_.options.autoSlidesToShow && !_.options.infinite && _.options.variableWidth) {
	          var sliderWidth = _.$slider.width();
	          var width = 0, length = _.$slides.length;
	          for (var i = 0; i < length; i++) {
	            width += $(_.$slides[i]).outerWidth();
	          }
	          _.averageSlidesWidth = width / length;
	          _.options.slidesToShow = Math.floor(sliderWidth / _.averageSlidesWidth) || 1;
	          //force update arrows
	          if (_.lastSlidesToShow !== _.options.slidesToShow) {
	            _.lastSlidesToShow = _.options.slidesToShow;
	            if (initial === true) {
	              _.currentSlide = _.options.initialSlide;
	            }
	            _.refresh(initial);
	          }
	        }
	        return checkResponsiveOrig.apply(this, arguments);
	      };
	      //hook getLeft method
	      var getLeftOrig = Slick.prototype.getLeft;
	      Slick.prototype.getLeft = function(slideIndex) {
	        var _ = this;
	        if (_.options.autoSlidesToShow && !_.options.infinite && _.options.variableWidth) {
	          var targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	          if (targetSlide[0]) {
	            var diff = 0;
	            if (slideIndex) {
	              var sliderWidth = _.$slider.width();
	              var otherSlidesWidth = (_.slideCount - slideIndex) * _.averageSlidesWidth;
	              if (otherSlidesWidth < sliderWidth) {
	                diff = sliderWidth - otherSlidesWidth;
	              }
	            }
	            return (targetSlide[0].offsetLeft - diff) * -1;
	          }
	          return  0;
	        }
	        return getLeftOrig.apply(this, arguments);
	      };
	    }
	  }
	})(jQuery);

	jQuery('.custom-mega').each(function() {
		var self = jQuery(this);
		jQuery('header.header li a[href$="#'+jQuery(this).attr('id')+'"]').eq(0).parent().append(self.clone())
		jQuery('header.header li a[href$="#'+jQuery(this).attr('id')+'"]').eq(1).parent().append(self)
	})

	jQuery('div#menu-drawer li a[href$="#pv"], div#menu-drawer li a[href$="#balk"], div#menu-drawer li a[href$="#info"]').click(function(e) {
		e.stopPropagation()
		jQuery(this).toggleClass('active').parent().find('.custom-mega').slideToggle()
		return false
	})



	jQuery('.header__inline-menu a[href$="#balk"], .header__inline-menu a[href$="#pv"], .header__inline-menu a[href$="#info"]').click(function(e) {

		e.preventDefault()

		if (!jQuery(this).hasClass('active')) {

			jQuery('.header__inline-menu a[href="#balk"], .header__inline-menu a[href="#pv"], .header__inline-menu a[href="#info"]').removeClass('active')
			jQuery('.custom-mega').hide()

			jQuery(this).addClass('active')
			jQuery('header.header').addClass('active')
            
			if (jQuery(this).hasClass('active')) {
				jQuery(this).next().show()
			}
		} else {

			jQuery('.header__inline-menu a[href$="#balk"], .header__inline-menu a[href$="#pv"], .header__inline-menu a[href$="#info"]').removeClass('active')
			jQuery('.custom-mega').hide()

			jQuery('header.header').removeClass('active')

		}

		return false
	})

	jQuery('.mega-menu').click(function() {
		
		if (!jQuery(this).is('[open]')) {
			jQuery('.header__inline-menu a[href$="#balk"], .header__inline-menu a[href$="#pv"], .header__inline-menu a[href$="#info"]').removeClass('active')
			jQuery('.custom-mega').hide()
			jQuery('header.header').addClass('active')
		} else {
			jQuery('header.header').removeClass('active')
		}
		

	})

	jQuery('.custom-mega-left-link.has-children').click(function(e) {
		e.stopPropagation()
		if (!jQuery(this).hasClass('active')) {
			jQuery('.custom-mega-left-link.has-children').removeClass('active')
			jQuery('.custom-mega-right-area').hide()

			jQuery(this).addClass('active');
			jQuery(this).parents('.custom-mega1-left').next().find('.custom-mega-right-area').eq(jQuery(this).index()).show()
		}
	})

	jQuery('.faq-item-q').click(function() {
		jQuery(this).toggleClass('active')
		jQuery(this).next().slideToggle()
	})

	jQuery('h1.main-page-title').each(function(){
	    var me = jQuery(this);
	    me.html( me.text().replace(/(^\w+)/,'<span>$1</span>') );
	});

	if (jQuery('.logos-line-inner').length > 0) {
		jQuery('.logos-line-inner').slick({
	        slidesToShow: 1,
	        arrows: false,
	        dots: false,
	        slidesToScroll: 1,
	        autoplay: true,
	        autoplaySpeed: 0,
	        speed: 6000,
	        centerMode: true,
	        variableWidth: true,
	        pauseOnHover: false,
	        cssEase: 'linear',
	        draggable: false,
	        swipe: false,
	        swipeToSlide: false,
	        touchMove: false,
	        accessibility: false,
	    });
	}

	if (jQuery('.testimonials-inner').length > 0 || jQuery('.products-slideshow-list').length > 0) {

	    jQuery('.testimonials-inner, .products-slideshow-list').slick({
			infinite: false,
			slidesToShow: 3,
			autoplay: false,
	      	arrows: true,
	      	slidesToScroll: 1,
	      	responsive: [
	      	    {
	      	      breakpoint: 1350,
	      	      settings: {
	      	      	autoSlidesToShow: true,
	      	      	arrows: true,
	      	      	dots: true,
	      	      	variableWidth: true,
	      	      	slidesToScroll: 1,
	      	      }
	      	    },
	      	 ]
		})
	}

	if (jQuery('.tutorials-slideshow').length > 0 || jQuery('.supply-slideshow').length > 0) {
		jQuery('.tutorials-slideshow, .supply-slideshow').slick({
			infinite: false,
			autoSlidesToShow: true,
			autoplay: false,
			variableWidth: true,
	      	arrows: true,
	      	slidesToScroll: 1,
	      	responsive: [
	      	    {
	      	      breakpoint: 1350,
	      	      settings: {
	      	      	arrows: true,
	      	      	dots: true,
	      	      	variableWidth: true,
	      	      }
	      	    },
	      	 ]
		})
	}

	if (jQuery('.blog-slides-inner').length > 0) {
		jQuery('.blog-slides-inner ul').slick({
			infinite: true,
			slidesToShow: 4,
	      	arrows: true,
	      	slidesToScroll: 1,
	      	autoplay: false,
	      	responsive: [
	      	    {
	      	      breakpoint: 1350,
	      	      settings: {
	      	      	arrows: true,
	      	      	dots: true,
	      	      	slidesToShow: 2,
	      	      	variableWidth: true,
	      	      }
	      	    },
	      	    {
	      	      breakpoint: 768,
	      	      settings: {
	      	      	slidesToShow: 1,
	      	      	variableWidth: true,
	      	      }
	      	    },
	      	 ]
		})
	}

	if (jQuery('.testims-inner').length > 0) {
		jQuery('.testims-inner').slick({
			infinite: true,
			slidesToShow: 3,
	      	arrows: false,
	      	slidesToScroll: 1,
	      	autoplay: false,
	      	responsive: [
	      	    {
	      	      breakpoint: 768,
	      	      settings: {
	      	      	slidesToShow: 1,
	      	      	arrows: true,
	      	      	dots: true,
	      	      }
	      	    },
	      	 ]
		})
	}

	if (jQuery('.team-inner').length > 0 && jQuery(window).width() < 1350) {
		jQuery('.team-inner').slick({
			setting: "unslick",
	      	responsive: [
	      		{
	      		  breakpoint: 5000,
	      		  settings: {
	      		  	arrows: true,
	      		  	dots: true,
	      		  	slidesToShow: 2,
	      		  	variableWidth: true,
	      		  	autoplay: false,
	      		  	settings: "unslick",
	      		  }
	      		},
	      	    {
	      	      breakpoint: 1350,
	      	      settings: {
	      	      	arrows: true,
	      	      	dots: true,
	      	      	variableWidth: true,
	      	      	autoplay: false,
	      	      }
	      	    },
	      	 ]
		})
	}

	if (jQuery('.custom-product-gallery-nav').length > 0) {
		jQuery('.custom-product-gallery-nav').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			asNavFor: '.custom-product-gallery-main',
			arrows: true,
			dots: false,
			vertical: true,
			infinite: false,
			focusOnSelect: true,
			centerMode: false,
		})

		jQuery('.custom-product-gallery-main').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.custom-product-gallery-nav',
			arrows: true,
			dots: false,
			fade: true,
			infinite: false,
			focusOnSelect: false,
			responsive: [
				{
	      	      breakpoint: 1350,
	      	      settings: {
	      	      	arrows: true,
	      	      	dots: true,
	      	      }
	      	    },
			]
		})
  	}

    new SimpleLightbox('.custom-product-gallery-main-item.product-image a', { /* options */ });

	jQuery('.testimonial-item').click(function() {
		jQuery(this).toggleClass('active')
	})

	jQuery('button.open-supply').click(function() {
		jQuery(this).toggleClass('active')
		jQuery(this).next().slideToggle().next().slideToggle()
	})

    jQuery('.accordeon-changing-texts-item-title').click(function() {
    	if (!jQuery(this).parent().hasClass('active')) {
    		jQuery('.accordeon-changing-texts-item').removeClass('active')
    		jQuery('.accordeon-changing-texts-item-text').slideUp()

    		jQuery('.accordeon-changing-texts-item-img').hide()

    		jQuery(this).parent().addClass('active')
    		jQuery(this).next().slideDown()

    		jQuery('.accordeon-changing-texts-item-img').eq(jQuery(this).parent().index()).show()
    	}
    })

    jQuery('.product-supply-full-list-video').click(function() {
    	jQuery(this).addClass('active')
    	jQuery(this).find('video').attr('controls', true)
    	jQuery('#overlay').show()
    })

    jQuery('.product-supply-full-list-video-title').click(function() {
    	jQuery(this).prev().trigger('click')
    })

    jQuery('.tutor-slide-video').click(function() {
    	jQuery(this).addClass('active')
    	jQuery(this).find('video').attr('controls', true)
    })

    jQuery('#overlay').click(function() {
	    if (jQuery('.product-supply-full-list-video.active video').length > 0) {
    		jQuery('.product-supply-full-list-video.active video').get(0).pause()
    	}
    	jQuery('.product-supply-full-list-video, .tutor-slide-video').removeClass('active')
    	jQuery('.product-supply-full-list-video video, .tutor-slide-video video').removeAttr('controls')
    	
    	jQuery('#overlay').hide()
    })

    jQuery(document).keyup(function(e) {
         if (e.key === "Escape") { 
            jQuery('#overlay').trigger('click')
        }
    });

    jQuery('.product-variant-select span, .product-variant-select svg').click(function() {
    	jQuery('.product-variant-select-list').toggleClass('active')
    })

    jQuery('.product-variant-select-list-item').click(function() {
    	// jQuery('.product-variant-select span').text(jQuery(this).text())
    	// jQuery('.bottom_bar_add_cart span').text(jQuery(this).data('price'))
    	jQuery('variant-selects label').eq(jQuery(this).index()).trigger('click')
    	jQuery('.product-variant-select-list').removeClass('active')
    })

    setTimeout(function() {
    	jQuery('variant-selects input:checked + label').trigger('click')
    }, 200)

    jQuery('.main-content-main-part').on('click', '.bottom_bar_add_cart', function() {
    	jQuery('.product-form__buttons button[name="add"]').trigger('click')

    	return false
    })

    jQuery('.main-content-main-part').on('click', 'variant-selects label', function() {
    	var myindex = jQuery('variant-selects label').index(jQuery(this))

    	if (jQuery(this).prev().data('img') != '') {
    		jQuery('.custom-product-gallery-nav .product-image').eq(0).find('img').attr('src', jQuery(this).prev().data('img'));
    		jQuery('.custom-product-gallery-main .product-image').eq(0).find('img').attr('src', jQuery(this).prev().data('img'));
    	}

    	jQuery('.product-variant-select span').text(jQuery('.product-variant-select-list-item').eq(myindex).text())
    	jQuery('.bottom_bar_add_cart span').text(jQuery('.product-variant-select-list-item').eq(myindex).data('price'))
    })

    jQuery('.hover-video-media').hover(function() {
    	jQuery(this).find('video').addClass('active').get(0).play()
    }, function() {
    	jQuery(this).find('video').removeClass('active').get(0).pause()
    })

    jQuery('.main-content-main-part').on('click', '.product-form__buttons button', function(e) {
    	if (!jQuery(this).hasClass('go') && jQuery('input[name="upsell"]:checked').length > 0 && jQuery('input[name="upsell"]:checked').data('product') != 0) {
    		e.preventDefault()

    		var self = this;

    		let formData = {
    		 'items': [{
    		  'id': parseInt(jQuery('input[name="upsell"]:checked').data('product')),
    		  'quantity': parseInt(jQuery('input[name="upsell"]:checked').data('amount'))
    		  }]
    		};

    		fetch(window.Shopify.routes.root + 'cart/add.js', {
    		  method: 'POST',
    		  headers: {
    		    'Content-Type': 'application/json'
    		  },
    		  body: JSON.stringify(formData)
    		})
    		.then(response => {
    		  jQuery(self).addClass('go')
    		  jQuery(self).trigger('click')
    		  return response.json();
    		})
    		.catch((error) => {
    		  console.error('Error:', error);
    		});
    	} else {

    	}
    })

    const currencyFractionDigits = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    }).resolvedOptions().maximumFractionDigits;

    if (jQuery('.upsell-item').length > 0) {
    	jQuery('.main-content-main-part').on('change', '.upsell-item input, variant-selects input', function() {

    		setTimeout(function(){
	    		let price1 = parseFloat(jQuery('.price-item-for-math').data('price'))
	    		let price2 = parseFloat(jQuery('.upsell-item input:checked').data('price'))

	    		let price = (price1 + price2).toLocaleString('de-DE', {
				    maximumFractionDigits: currencyFractionDigits 
				});

				jQuery('.bottom_bar_add_cart span').text('€'+price)
                jQuery('span.price-item').text('€'+price+' EUR')
    		}, 250)
    		
    	})
    }

    if (jQuery('.list-bg-video-info-list').length) {
	    jQuery(window).on( 'scroll', function(){
	        isInViewport();
	    });

	    const isInViewport = function() {
	        const middleOfScreen = jQuery(window).scrollTop() + jQuery(window).height()/2;

	        jQuery('.list-bg-video-info-list .bg-video-list-item').each(function(){
	            const element = jQuery(this);
	            const elementHeight = element.outerHeight();
	            
	            let topOfElement = 0;
	            if (element.length) {
	                topOfElement = element.offset().top - 25;
	            }
	            
	            const bottomOfElement = topOfElement + elementHeight + 50;

	            if ((middleOfScreen > topOfElement) && (middleOfScreen <  bottomOfElement)) {
	                element.addClass('active');
	            } else {
	                element.removeClass('active');
	            }
	        })
	    }

	    jQuery('.bg-video-list-item-img img').each(function(){
	        var $img = jQuery(this);
	        var imgID = $img.attr('id');
	        var imgClass = $img.attr('class');
	        var imgURL = $img.attr('src');

	        jQuery.get(imgURL, function(data) {
	            // Get the SVG tag, ignore the rest
	            var $svg = jQuery(data).find('svg');

	            // Add replaced image's ID to the new SVG
	            if(typeof imgID !== 'undefined') {
	                $svg = $svg.attr('id', imgID);
	            }
	            // Add replaced image's classes to the new SVG
	            if(typeof imgClass !== 'undefined') {
	                $svg = $svg.attr('class', imgClass+' replaced-svg');
	            }

	            // Remove any invalid XML tags as per http://validator.w3.org
	            $svg = $svg.removeAttr('xmlns:a');

	            // Replace image with new SVG
	            $img.replaceWith($svg);

	        }, 'xml');

	    });
	}

    jQuery('a.mobile-open-more.has-children').click(function(e) {

    	e.stopPropagation()

    	jQuery(this).toggleClass('active')
    	jQuery(this).next().slideToggle()
    	jQuery(this).next().next().slideToggle()

    	return false
    })

    jQuery(document).mouseup(function(e) {
        var container = jQuery("header.header");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0 && container.hasClass('active')) {
        	container.removeClass('active')
            jQuery('a[href="#pv"], a[href="#balk"], a[href="#info"]').removeClass('active')
            jQuery('.custom-mega').hide()
        }
    });



})

jQuery(window).on('load', function() {
	var url_string = window.location.href
	var url = new URL(url_string);
	var c = url.searchParams.get("contact_posted");

	if (c != null && c == 'true') {
		jQuery('html, body').animate({
			scrollTop: jQuery('form#contact_form').parents('.shopify-section').offset().top - 150
		})

		jQuery('.business-contact-form form').hide()
		jQuery('.success').show()
	}


})